import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

const styles = () => ({
  ...modalStyles()
});

class PurchaseDisabledModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { classes, settings } = this.props;

    let moreImagesAvailable = settings.catalog_screen;
    let modalText;
    if (moreImagesAvailable) {
      modalText = messages.kiosk_purchase_disabled_instructions_more_images;
    } else {
      modalText = messages.kiosk_purchase_disabled_instructions;
    }

    return (
      <Modal disableScrollbar={true}
        open={this.props.open}
        onClose={() => this.props.onClose()}>
        <div className={classes.modalOverlay} onClick={() => this.props.onClose()}></div>
        <div className={classes.modal}>
          <CloseIcon className={classes.modalCloseIcon} onClick={() => this.props.onClose()} />
          <div className={classes.modalStage}>
            <div className={classes.modalSlider}>
              <div className={classes.modalSlide}>
	        <p className={classes.modalText}>
                  <FormattedMessage {...modalText} />
                </p>
              </div>
            </div>
          </div>
          <div className={classes.modalButtons}>
            <button className={classes.modalButton} onClick={() => this.onClose()} style={{width: '100%', marginTop: '1.5rem'}}>
              <FormattedMessage {...messages.button_ok} />
            </button>
          </div>
        </div>
      </Modal>
    );

  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings
});

export default connect(mapStateToProps)(withStyles(styles)(PurchaseDisabledModal));
